<template>
  <button
    :class="{ 'hamburger--is-active': isActive }"
    class="hamburger"
    @click="handleClick"
  >
    <span class="hamburger__icon"/>
  </button>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('click', !this.isActive)
    }
  }
}
</script>

<style lang="scss" scoped>
  $plus-size: 24px;

  .hamburger {
    @include reset-button;

    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: $border-width solid;
    @include theme(border-color);
    transition: border-color $base-transition;

    &--is-active {
      border-color: $main-opposite-color;
    }

    &__icon {
      display: block;
      width: $plus-size;
      height: $plus-size;
      position: relative;

      margin: 0 auto;

      transform: rotate(180deg);
      transition: transform $base-transition;

      &::before,
      &::after {
        @include theme(background-color);
        content: '';
        position: absolute;
        top: calc(50% - #{$border-width / 2});
        left: 0;
        width: $plus-size;
        height: $border-width;
        transition: background-color $base-transition,
                    transform $base-transition;
      }

      &::after {
        transform: rotate(90deg);
        transform-origin: center;
      }
    }

    &--is-active &__icon {
      transform: rotate(0);

      &::before,
      &::after {
        background-color: $main-opposite-color;
      }

      &::after {
        transform: rotate(0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Navigation/Hamburger.vue